import type { GetFeatureFlagOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export type GetFeatureFlagQueryParams = Omit<GetFeatureFlagOpenAPIQueryParams, 'env' | 'expand'> & {
  env?: string[];
  expand?: Array<'evaluation' | 'views'>;
};

export function querySerializer(queryParams: GetFeatureFlagQueryParams) {
  const searchParams = new URLSearchParams();

  if (queryParams.env) {
    for (const env of queryParams.env) {
      searchParams.append('env', env);
    }
  }

  // NOTE: This is a temporary fix to ensure every query for a flag includes the migration settings.
  // In the future, we may update the endpoint to include migration settings for migration flags by default.
  const expand: string[] = [...(queryParams.expand ?? []), 'migrationSettings'];

  searchParams.set('expand', expand.join(','));

  return searchParams.toString();
}
